import React from 'react';
import { Box, Typography } from '@mui/material';
import { LAYOUT } from '../../utils/layoutConstants';
import './JLLFooter.css';

const JLLFooter = ({ sidebarOpen }) => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#000000',
        color: '#FFFFFF',
        py: 1.5,
        mt: 'auto',
        borderTop: '3px solid #09ad40',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        zIndex: 1100,
      }}
    >
      <Box
        sx={{
          px: 4,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: `${LAYOUT.CONTENT_MAX_WIDTH}px`,
          mx: 'auto',
        }}
      >
        <Typography variant="body2" sx={{ fontSize: '0.75rem', opacity: 0.9 }}>
          © {currentYear} JLL. All rights reserved.
        </Typography>

        <Typography variant="body2" sx={{ fontSize: '0.75rem', fontWeight: 500, opacity: 0.9 }}>
          Survey AI Analytics
        </Typography>
      </Box>
    </Box>
  );
};

export default JLLFooter;
